/* import __COLOCATED_TEMPLATE__ from './universal-robot.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();